export const CandidateState = "Candidate";
export const PreScreeningState = "Pre-screening"
export const ScreeningState = "Screening";
export const AiInterviewState = "AI interview";
export const InPersonState = "Interview";
